var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.125C5.20304 2.125 2.125 5.20304 2.125 9C2.125 12.797 5.20304 15.875 9 15.875C12.797 15.875 15.875 12.797 15.875 9C15.875 5.20304 12.797 2.125 9 2.125ZM0.875 9C0.875 4.51269 4.51269 0.875 9 0.875C13.4873 0.875 17.125 4.51269 17.125 9C17.125 13.4873 13.4873 17.125 9 17.125C4.51269 17.125 0.875 13.4873 0.875 9ZM8.375 5.875C8.375 5.52982 8.65482 5.25 9 5.25H9.00625C9.35143 5.25 9.63125 5.52982 9.63125 5.875V5.88125C9.63125 6.22643 9.35143 6.50625 9.00625 6.50625H9C8.65482 6.50625 8.375 6.22643 8.375 5.88125V5.875ZM8.13007 7.7987C9.08526 7.3211 10.1608 8.18384 9.90176 9.2199L9.31092 11.5833L9.34548 11.566C9.65422 11.4116 10.0296 11.5367 10.184 11.8455C10.3384 12.1542 10.2133 12.5296 9.90452 12.684L9.86994 12.7013C8.91475 13.1789 7.83923 12.3162 8.09824 11.2801L8.68908 8.91673L8.65451 8.93402C8.34577 9.08838 7.97035 8.96325 7.81598 8.65451C7.66161 8.34577 7.78675 7.97035 8.09549 7.81598L8.13007 7.7987Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg18);
export default __webpack_public_path__ + "static/media/svg18.4e498e376aca19c8e12b64793e63d3ab.svg";
export { ForwardRef as ReactComponent };